import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';

type CollapsibleNavGroupHeaderProps = {
  label: string;
  isExpanded: boolean;
  onToggle: () => void;
  /** Optional trailing control (e.g. a create button) rendered outside the toggle area. */
  action?: React.ReactNode;
};

/**
 * Collapsible group header for the Analytics/Settings sub-navigation. The chevron and title share a
 * single toggle button so they read as one control with a unified hover state.
 */
export const CollapsibleNavGroupHeader = ({
  label,
  isExpanded,
  onToggle,
  action,
}: CollapsibleNavGroupHeaderProps) => {
  return (
    <div className="flex items-center">
      <button
        type="button"
        className="flex flex-1 items-center rounded text-left text-sm font-medium text-foreground transition-colors hover:bg-selected-soft"
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        <span aria-hidden className="flex h-6 w-6 shrink-0 items-center justify-center">
          {isExpanded ? (
            <ChevronDownIcon className="h-4 w-4 text-muted-foreground" />
          ) : (
            <ChevronRightIcon className="h-4 w-4 text-muted-foreground" />
          )}
        </span>
        <span className="flex-1 px-1.5 py-1.5">{label}</span>
      </button>
      {action}
    </div>
  );
};
